import { selfAxios } from "../../../../axios/selfAxios.js";
async function opPostGetShopManageRightByCondition(params) {
  const res = await selfAxios.post(`/designordercenter/productionOrderMarketConfig/getShopManageRightByCondition`, params, { _cache: true });
  return res.data;
}
export { opPostGetShopManageRightByCondition };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/productionOrderMarketConfig/getShopManageRightByCondition/post.js